<script lang="ts">
    import IconifyIcon from '@iconify/svelte'
    import star from '@iconify/icons-fa-solid/star'
    import starHalfAlt from '@iconify/icons-fa-solid/star-half-alt'
    import googlePlayBtnImage from 'src/components/main/#common/game-card/google-play.svg'

    export let image
    export let title
    export let willBeIn = false
    export let link = null
    export let rating = null
    export let reviews = null
    let target
    $: target = link ? '_blank' : '_self'
</script>

<div class="game-card">
    <a href="{link}" class="image" target="{target}">
        <img src="{image}" alt="{title}">
    </a>
    <div class="game-card-body">
        <div class="title-reviews">
            <a href="{link}" class="game-name" target="{target}">{title}</a>
            <div class="game-rating-reviews">
                <div class="game-rating">
                    <IconifyIcon class="star-icon" icon={star}/>
                    <IconifyIcon class="star-icon" icon={star}/>
                    <IconifyIcon class="star-icon" icon={star}/>
                    <IconifyIcon class="star-icon" icon={star}/>
                    <IconifyIcon class="star-icon" icon={starHalfAlt}/>
                </div>
            </div>
        </div>
        <div class="reviews-count">{reviews} reviews</div>
        <a href="{link}" class="game-link" target="_blank">
            <img src={googlePlayBtnImage} alt="">
        </a>
    </div>
</div>

<style>
    .game-card {
        background: #282D39;
        border-radius: 3px;
        overflow: hidden;
        max-width: 450px;
        margin: 0 auto 30px;
        padding: 30px 30px 50px;
        border: 2px solid #282D39;
        z-index: 2;
        position: relative;
        transition: .6s;
    }

    .game-card:hover {
        border-color: #5E627E;
        box-shadow: 0 0 35px 15px rgba(94, 98, 126, 0.4);
    }

    .game-card-body {
        padding: 20px 0 0;
    }

    .image img {
        width: 100%;
        border-radius: 3px;
        transition: .6s;
    }

    .game-card:hover .image img {
        width: calc(100% + 60px);
        margin: -40px -30px 0;
        border-radius: 3px 3px 0 0;
    }

    .title-reviews {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
    }

    .reviews-count {
        color: #A0AEC0;
        margin-bottom: 30px;
        font-size: 14px;
        font-weight: 300;
    }

    .game-card :global(.star-icon) {
        color: #F3BD38;
        vertical-align: top;
    }

    .game-name {
        font-size: 25px;
        line-height: normal;
        color: white;
        text-decoration: none;
        font-weight: 500;
    }

    .game-rating-reviews {
        display: flex;
        justify-content: space-between;
        color: white;
        font-size: 14px;
        margin: 8px 0 0;
    }

    .game-link {
        display: block;
        transition: .25s;
    }

    .game-link img {
        width: 175px;
    }

    .game-reviews span {
        padding-left: 2px;
    }

    .game-card.disabled .game-link {
        opacity: 0.7;
    }

    .game-link:hover {
        opacity: 0.85;
    }

    @media (max-width: 1400px) {
        .game-name {
            font-size: 30px;
            width: 100%;
            margin-bottom: 5px;
        }

        .title-reviews {
            flex-wrap: wrap;
            margin-bottom: 5px;
        }
    }

    @media (max-width: 1200px) {
        .game-rating-reviews {
            font-size: 15px;
        }

        .game-name {
            font-size: 22px;
        }

        .game-card {
            padding: 20px 20px 25px;
        }
    }

    @media (max-width: 992px) {
        .game-card {
            padding: 10px 10px 15px;
        }

        .game-name {
            font-size: 20px;
        }
    }

    @media (max-width: 767px) {
        .game-card {
            padding: 20px 20px 30px;
            margin-bottom: 24px;
        }

        .game-name {
            font-size: 20px;
            line-height: 24px;
        }

        .game-rating-reviews {
            font-size: 16px;
        }

        .game-link img {
            width: 175px;
        }

        .reviews-count {
            margin-bottom: 20px;
        }
    }
</style>
